export const EMPTY_ARRAY = Object.freeze([]) as [];
export const EMPTY_MAP = Object.freeze(new Map()) as Map<any, any>;
export const EMPTY_OBJECT = Object.freeze({}) as EmptyObject;
